function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-control-next_svg__a",
  d: "M21 21.609L4.943 11.667l16.056-9.32v19.262zm.508-21.61a1.75 1.75 0 00-.883.253L3.367 10.269c-.139.08-.26.173-.368.276V1.007a1 1 0 10-2 0v22a1 1 0 102 0V12.76c.1.095.208.183.332.26l17.282 10.702c.298.184.607.278.917.278.731 0 1.47-.561 1.47-1.632V1.646C23 .692 22.373 0 21.508 0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "icon-control-next_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-control-next_svg__a"
})), React.createElement("use", {
  transform: "matrix(-1 0 0 1 23.999 0)",
  xlinkHref: "#icon-control-next_svg__a"
}), React.createElement("g", {
  mask: "url(#icon-control-next_svg__b)"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
})));

var SvgIconControlNext = function SvgIconControlNext(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconControlNext;